/* A presentation layer over CPB's original size controls. CPB remains the
   authority for dimensions, limits, configuration persistence and pricing. */
(function () {
  'use strict';
  if (location.pathname !== '/products/custom-infinity-mirror') return;
  var IDs = {
    mode: 'LB4oi7z56Ta0OZehKxWNh6o0', preset: 'ChhzZNLNHc6HoBDjegeEYT4G', custom: 'hHvqdwVPeJimgKlbmK7ysr_Y',
    units: 'SAvhX7xAkC66xUbZf1toKKOW', inches: 'qozMiWf1p8mmW7MYIUZWAx8q',
    inchFields: 'aE4hNil-ULOoL_nuXhFekRZl', cmFields: 'dbIF9OR5ZazT43lgZsJxGlfh',
    shape: '9Qos5yoFhBABVdL2vB4VBl0o'
  };
  var names = ['compact', 'classic', 'statement', 'gallery', 'feature', 'grand'];
  var lengths = [18, 24, 36, 48, 60, 72];
  var sliderMax = 96;
  var labels = window.__MYX_SIZE_LABELS__;
  if (!labels) return;
  var host, pending, running = false, debounce = 0, refreshTimer = 0, lastShape = '';
  var shapeTransfer = null;
  var previewTransfer = null, previewTimer = 0, previewRelease = 0;
  var geometryKeys = ['shape', 'size', 'sizePresetShort', 'sizeMode', 'sizeUnit', 'sizeCustomWidth', 'sizeCustomLength'];
  function pricingPending(value) {
    var root = document.documentElement, next = value ? 'true' : 'false';
    if (root.dataset.myxSizePending === next) return;
    root.dataset.myxSizePending = next;
    document.dispatchEvent(new CustomEvent(value ? 'maytrix:size-pending' : 'maytrix:size-committed'));
  }
  function category(id) { return document.querySelector('#product-builder [data-category-id="' + id + '"]'); }
  function option(id) { return document.querySelector('#product-builder [data-option-id="' + id + '"]'); }
  function active(node) { return node && (node.classList.contains('cpb-active') || node.getAttribute('aria-pressed') === 'true' || node.getAttribute('aria-checked') === 'true'); }
  function shape() {
    var node = category(IDs.shape)?.querySelector('.cpb-active');
    return node?.getAttribute('data-maytrix-shape') || '';
  }
  function square(kind) { return ['square', 'circle', 'octagon'].includes(kind); }
  function vertical(kind) { return ['vrect', 'voval', 'arch'].includes(kind); }
  function dimensions(long, kind) {
    var short = square(kind) ? long : long / 2;
    return { width: vertical(kind) ? short : long, height: vertical(kind) ? long : short };
  }
  function fields() {
    var inches = category(IDs.inchFields), cm = category(IDs.cmFields), node = inches || cm;
    var inputs = node && Array.from(node.querySelectorAll('.cpb-counter input[type="number"]'));
    return inputs?.length === 2 ? { inputs: inputs, factor: inches ? 1 : 2.54 } : null;
  }
  function current() {
    var kind = shape();
    if (!kind) return null;
    if (active(option(IDs.preset))) {
      var selected = window.__MAYTRIX_SIGNATURE_SIZES__?.getSelection(kind);
      return selected ? { width: selected.width, height: selected.height } : null;
    }
    var controls = fields();
    if (!controls) return null;
    // A counter can show an uncommitted draft. Read CPB's saved layer values
    // whenever available so preview/pricing completion is never inferred from it.
    var product = window.CPB?.getStore?.()?.getState?.()?.Product;
    if (Array.isArray(product?.layers)) {
      var id = controls.factor === 1 ? IDs.inchFields : IDs.cmFields;
      var native = product.panels?.flatMap(function (panel) { return panel.categories || []; }).find(function (item) { return item.id === id; });
      if (native?.options?.length === 2) {
        var values = native.options.map(function (item) {
          var layer = product.layers.find(function (layer) { return layer.category === id && layer.option === item.id; });
          return layer?.value === '' || layer?.value == null ? NaN : Number(layer.value) / controls.factor;
        });
        return values.every(Number.isFinite) ? { width: values[0], height: values[1] } : null;
      }
    }
    var width = Number(controls.inputs[0].value) / controls.factor;
    var height = Number(controls.inputs[1].value) / controls.factor;
    return Number.isFinite(width) && Number.isFinite(height) ? { width: width, height: height } : null;
  }
  function equal(a, b) { return a && b && Math.abs(a.width - b.width) < 0.005 && Math.abs(a.height - b.height) < 0.005; }
  function geometry(value, kind) {
    var preset = lengths.some(function (long) { return equal(value, dimensions(long, kind)); });
    return { shape: kind, size: Math.max(value.width, value.height), sizePresetShort: Math.min(value.width, value.height),
      sizeMode: preset ? 'preset' : 'custom', sizeUnit: 'in', sizeCustomWidth: value.width, sizeCustomLength: value.height };
  }
  function clearPreviewTransfer(reconcile) {
    clearTimeout(previewTimer); clearTimeout(previewRelease); previewTransfer = null;
    var value = reconcile && current(), kind = shape();
    if (value && kind) window.__MAYTRIX_VIEWER__?.setState(geometry(value, kind));
  }
  function holdPreview(value, kind) {
    clearTimeout(previewTimer); clearTimeout(previewRelease);
    var transfer = previewTransfer = { kind: kind, value: { width: value.width, height: value.height }, expires: Date.now() + 10000 };
    // Both CPB geometry bridges consult this resolver before publishing. Keep
    // their temporary family default out of the scene while native pricing settles.
    window.__MAYTRIX_VIEWER__?.setState(geometry(value, kind));
    previewTimer = setTimeout(function () { if (previewTransfer === transfer) clearPreviewTransfer(true); }, 10000);
  }
  function finishPreviewTransfer() {
    var transfer = previewTransfer;
    if (!transfer || running || pending || shapeTransfer || shape() !== transfer.kind || !equal(current(), transfer.value)) return;
    clearTimeout(previewRelease);
    // CPB schedules a few follow-up notifications after its selected option has
    // changed. Keep those from repainting the former size during their final turn.
    previewRelease = setTimeout(function () {
      if (previewTransfer !== transfer || running || pending || shapeTransfer) return;
      if (shape() === transfer.kind && equal(current(), transfer.value)) clearPreviewTransfer(true);
    }, 420);
  }
  window.__MAYTRIX_SIZE_TRANSITION__ = {
    resolve: function (patch) {
      if (!previewTransfer) return patch;
      if (Date.now() >= previewTransfer.expires) { clearPreviewTransfer(false); return patch; }
      return geometryKeys.some(function (key) { return patch[key] !== undefined; })
        ? Object.assign({}, patch, geometry(previewTransfer.value, previewTransfer.kind)) : patch;
    }
  };
  function number(value) { return String(Number(value.toFixed(2))); }
  function dimensionLabel(value) { return number(value.width) + '″ × ' + number(value.height) + '″'; }
  function text(node, value) { if (node.textContent !== value) node.textContent = value; }
  function attr(node, name, value) { if (node.getAttribute(name) !== String(value)) node.setAttribute(name, value); }
  function element(tag, className, content) {
    var node = document.createElement(tag); if (className) node.className = className;
    if (content) node.textContent = content; return node;
  }
  function button(className, content) { var node = element('button', className, content); node.type = 'button'; return node; }
  function make() {
    var wrap = element('div', 'myx-unified-size');
    var weight = element('p', 'myx-size-weight');
    weight.setAttribute('role', 'status'); weight.setAttribute('aria-live', 'polite'); weight.setAttribute('aria-atomic', 'true');
    weight.append(element('span', '', 'Estimated weight: '), element('strong', 'myx-size-weight-value'));
    weight.hidden = true; wrap.append(weight);
    var grid = element('div', 'myx-size-grid'); grid.setAttribute('role', 'group'); grid.setAttribute('aria-label', 'Size');
    names.forEach(function (name, index) {
      var card = button('myx-size-card'); card.dataset.sizeIndex = index;
      card.append(element('strong', 'myx-size-name', labels[name]), element('span', 'myx-size-dimensions'), element('span', 'myx-size-badge', '★ ' + labels.recommended));
      card.addEventListener('click', function () { queue(dimensions(lengths[index], shape()), 0); }); grid.append(card);
    });
    wrap.append(grid);
    var scale = element('div', 'myx-size-scale');
    scale.setAttribute('role', 'group'); scale.setAttribute('aria-label', labels.scale);
    var summary = element('div', 'myx-size-summary');
    var output = element('output', 'myx-size-summary-value'); output.htmlFor = 'myx-unified-scale';
    summary.append(element('span', '', labels.scale), output);
    scale.append(summary);
    var range = element('input'); range.type = 'range'; range.id = 'myx-unified-scale';
    range.setAttribute('aria-label', labels.scale);
    function scaleChange(event) { event.stopPropagation(); queue(dimensions(Number(range.value), shape()), event.type === 'change' ? 0 : 100); }
    range.addEventListener('input', scaleChange); range.addEventListener('change', scaleChange); scale.append(range); wrap.append(scale);
    // The slider lives inside CPB's size-mode category. Its arrow keys must
    // adjust the range, not also navigate CPB's hidden preset/custom options.
    range.addEventListener('keydown', function (event) { event.stopPropagation(); });
    // Custom sizing stays fully visible; there is no disclosure or manual-entry toggle.
    var rows = element('div', 'myx-size-counters'); rows.id = 'myx-manual-size-fields';
    ['width', 'height'].forEach(function (axis) {
      var field = element('div', 'myx-size-field'), fieldLabel = element('label', '', labels[axis]);
      fieldLabel.htmlFor = 'myx-unified-' + axis;
      var controls = element('div', 'myx-size-counter'), input = element('input');
      input.type = 'number'; input.inputMode = 'decimal'; input.id = fieldLabel.htmlFor; input.step = '0.1'; input.min = '0';
      input.setAttribute('aria-label', labels[axis] + ' in inches');
      var minus = button('', '−'), plus = button('', '+');
      minus.setAttribute('aria-label', labels.decrease + ' ' + labels[axis].toLowerCase());
      plus.setAttribute('aria-label', labels.increase + ' ' + labels[axis].toLowerCase());
      function step(direction) {
        var value = pending || current(); if (!value) return;
        var next = { width: value.width, height: value.height };
        next[axis] = Number((next[axis] + direction * Number(input.step)).toFixed(2));
        if (next[axis] < Number(input.min) || (input.max !== '' && next[axis] > Number(input.max))) return;
        queue(next, 80);
      }
      minus.addEventListener('click', function () { step(-1); }); plus.addEventListener('click', function () { step(1); });
      function edit(event) {
        event.stopPropagation();
        if (!input.checkValidity() || input.value === '') { paint(); return; }
        var value = pending || current(); if (!value) return;
        var next = { width: value.width, height: value.height }; next[axis] = Number(input.value); queue(next, event.type === 'input' ? 220 : 0);
      }
      input.addEventListener('input', edit); input.addEventListener('change', edit);
      input.addEventListener('keydown', function (event) { if (event.key === 'Enter') { event.preventDefault(); input.blur(); } });
      controls.append(minus, input, element('span', 'myx-size-unit', 'in'), plus); field.append(fieldLabel, controls); rows.append(field);
    });
    scale.append(rows);
    var error = element('p', 'myx-size-error'); error.setAttribute('role', 'status'); error.hidden = true; wrap.append(error);
    return wrap;
  }
  function paint(value) {
    if (!host?.isConnected) return;
    value = value || pending || current(); var kind = shape();
    var weight = host.querySelector('.myx-size-weight');
    // Use the same inches-based estimate and rounding as the review/shop drawings.
    var lbs = value && Math.round(value.width * value.height * 0.0595 / 5) * 5;
    weight.hidden = !value || !Number.isFinite(lbs) || lbs <= 0;
    if (!weight.hidden) text(weight.querySelector('.myx-size-weight-value'), '~' + lbs + ' lb');
    if (!value || !kind) return;
    host.querySelectorAll('.myx-size-card').forEach(function (card, index) {
      var size = dimensions(lengths[index], kind), recommended = index === (square(kind) ? 2 : 3);
      text(card.querySelector('.myx-size-dimensions'), dimensionLabel(size));
      attr(card, 'aria-pressed', equal(value, size));
      attr(card, 'aria-label', labels[names[index]] + ', ' + dimensionLabel(size) + (recommended ? ', ' + labels.recommended : ''));
      card.querySelector('.myx-size-badge').hidden = !recommended;
      attr(card, 'data-recommended', recommended);
    });
    var range = host.querySelector('input[type="range"]'), min = square(kind) ? 12 : 18;
    attr(range, 'min', min); attr(range, 'max', sliderMax); attr(range, 'step', square(kind) ? 0.1 : 0.2);
    var long = Math.max(min, Math.min(sliderMax, Math.max(value.width, value.height)));
    if (range.value !== String(long)) range.value = String(long);
    attr(range, 'aria-valuetext', number(value.width) + ' by ' + number(value.height) + ' inches');
    range.style.setProperty('--myx-scale-progress', ((long - min) / (sliderMax - min) * 100) + '%');
    text(host.querySelector('output'), dimensionLabel(value));
    var native = fields();
    ['width', 'height'].forEach(function (axis, index) {
      var input = host.querySelector('#myx-unified-' + axis);
      if (document.activeElement !== input) input.value = number(value[axis]);
      // Preserve CPB's counter bounds; the slider is capped at 96 inches without changing saved/manual dimensions.
      if (native && native.factor === 1) {
        ['min', 'max', 'step'].forEach(function (key) { if (native.inputs[index].hasAttribute(key)) attr(input, key, native.inputs[index].getAttribute(key)); else input.removeAttribute(key); });
      }
      var controls = input.closest('.myx-size-counter');
      controls.firstElementChild.disabled = value[axis] <= Number(input.min || 0);
      controls.lastElementChild.disabled = input.max !== '' && value[axis] >= Number(input.max);
    });
  }
  function assertCurrent(kind, target) {
    if (shape() !== kind) throw new Error('Shape changed');
    if (target && pending !== target) throw new Error('Size superseded');
  }
  function waitFor(test, kind, target) {
    var started = Date.now();
    return new Promise(function (resolve, reject) {
      function check() {
        try { assertCurrent(kind, target); } catch (error) { reject(error); return; }
        var result = test(); if (result) { resolve(result); return; }
        if (Date.now() - started > 7000) { reject(new Error('Size update timed out')); return; }
        setTimeout(check, 60);
      }
      check();
    });
  }
  function settle(ms) { return new Promise(function (resolve) { setTimeout(resolve, ms); }); }
  async function commitField(index, value, kind, target) {
    function saved() { var value = current(); return value && value[index === 0 ? 'width' : 'height']; }
    function latest() {
      var controls = fields(), input = controls?.inputs[index];
      if (!input || controls.factor !== 1 || input.isConnected === false) throw new Error('Inch controls unavailable');
      return input;
    }
    function write(input) {
      Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set.call(input, String(value));
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input = latest();
      if (Math.abs(Number(input.value) - value) >= 0.005) Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set.call(input, String(value));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    for (var attempt = 0; attempt < 3; attempt++) {
      assertCurrent(kind, target);
      if (Math.abs(saved() - value) < 0.005) return;
      write(latest());
      await settle(30); assertCurrent(kind, target);
      var input = latest();
      if (Math.abs(Number(input.value) - value) >= 0.005) write(input);
      // React may replace either the input or apply button on every change.
      // Reacquire both instead of blurring/clicking their detached predecessors.
      latest().dispatchEvent(new FocusEvent('focusout', { bubbles: true }));
      latest().closest('.cpb-counter')?.querySelector('.cpb-counter-apply')?.click();
      await settle(350); assertCurrent(kind, target);
      if (Math.abs(saved() - value) < 0.005) return;
    }
    throw new Error('Size update timed out');
  }
  async function commit(value, kind) {
    assertCurrent(kind, value);
    var index = lengths.findIndex(function (long) { return equal(value, dimensions(long, kind)); });
    if (index >= 0) {
      if (!active(option(IDs.preset))) option(IDs.preset)?.click();
      await waitFor(function () { return active(option(IDs.preset)) && window.__MAYTRIX_SIGNATURE_SIZES__?.getChoices(kind).some(function (choice) { return choice.optionId && equal(choice, value); }); }, kind, value);
      var choice = window.__MAYTRIX_SIGNATURE_SIZES__.getChoices(kind).find(function (item) { return equal(item, value); });
      if (!active(option(choice.optionId))) option(choice.optionId)?.click();
      await waitFor(function () { return equal(current(), value); }, kind, value);
      await settle(350);
      return;
    }
    if (!active(option(IDs.custom))) option(IDs.custom)?.click();
    await waitFor(function () { return active(option(IDs.custom)) && category(IDs.units); }, kind, value);
    if (!active(option(IDs.inches))) option(IDs.inches)?.click();
    await waitFor(function () { return active(option(IDs.inches)) && fields()?.factor === 1; }, kind, value);
    await commitField(0, value.width, kind, value); await commitField(1, value.height, kind, value);
    await waitFor(function () { return equal(current(), value); }, kind, value);
  }
  function queue(value, delay) {
    if (!shape() || !Number.isFinite(value.width) || !Number.isFinite(value.height)) return;
    pending = { width: value.width, height: value.height, kind: shape() };
    pricingPending(true);
    if (previewTransfer?.kind === pending.kind) holdPreview(pending, pending.kind);
    host.querySelector('.myx-size-error').hidden = true; paint(pending);
    clearTimeout(debounce); debounce = setTimeout(flush, delay);
  }
  function carrySizeToShape(event) {
    if (!event.isTrusted) return;
    if (event.type === 'keydown' && (event.repeat || !['Enter', ' '].includes(event.key))) return;
    var card = event.target.closest?.('[data-maytrix-shape][data-option-id]');
    if (!card || !category(IDs.shape)?.contains(card)) return;
    var next = card.getAttribute('data-maytrix-shape'), before = shape();
    if (!next || next === before) return;
    // Capture the shopper's size before CPB swaps its separate square/rectangle
    // categories. Only real shape choices transfer size, never example or saved restores.
    var value = pending || (shapeTransfer && shapeTransfer.value) || current();
    if (!value) return;
    var long = Math.max(value.width, value.height);
    if (!Number.isFinite(long) || long <= 0) return;
    var mapped = dimensions(Math.max(square(next) ? 12 : 18, long), next);
    // Native custom counters round to tenths of an inch (e.g. 48.1 / 2 -> 24.1).
    mapped.width = Math.round(mapped.width * 10) / 10;
    mapped.height = Math.round(mapped.height * 10) / 10;
    shapeTransfer = { kind: next, value: mapped, at: Date.now() };
    pricingPending(true);
    holdPreview(mapped, next);
    pending = null; clearTimeout(debounce); schedule();
  }
  async function flush() {
    if (running || !pending) return;
    running = true;
    try {
      while (pending) {
        var target = pending;
        var previewAtCommit = previewTransfer;
        if (target.kind !== shape()) { pending = null; break; }
        if (!equal(current(), target)) await commit(target, target.kind);
        if (pending === target) pending = null;
      }
    } catch (error) {
      if (pending === target) pending = null;
      if (previewTransfer === previewAtCommit && !pending && !shapeTransfer) clearPreviewTransfer(true);
      if (host?.isConnected && shape() === lastShape && !['Shape changed', 'Size superseded'].includes(error.message)) {
        text(host.querySelector('.myx-size-error'), labels.error); host.querySelector('.myx-size-error').hidden = false;
      }
    } finally { running = false; paint(); if (pending) debounce = setTimeout(flush, 0); else { pricingPending(!!shapeTransfer); finishPreviewTransfer(); } }
  }
  function refresh() {
    var mode = category(IDs.mode), kind = shape();
    if (!mode || !kind || !current()) return;
    if (lastShape && lastShape !== kind && pending?.kind !== kind) { pending = null; clearTimeout(debounce); }
    lastShape = kind;
    if (!host?.isConnected) { host = make(); mode.append(host); }
    if (!mode.classList.contains('myx-size-native-mode')) mode.classList.add('myx-size-native-mode');
    document.getElementById('product-builder').classList.add('myx-unified-sizing');
    if (shapeTransfer && Date.now() - shapeTransfer.at > 2000) { shapeTransfer = null; if (!pending && !running) { clearPreviewTransfer(true); pricingPending(false); } }
    if (shapeTransfer?.kind === kind) {
      var transfer = shapeTransfer; shapeTransfer = null; queue(transfer.value, 0);
    }
    if (!running) paint();
  }
  function schedule() { if (!refreshTimer) refreshTimer = setTimeout(function () { refreshTimer = 0; refresh(); }, 60); }
  function start() {
    document.addEventListener('click', carrySizeToShape, true);
    document.addEventListener('keydown', carrySizeToShape, true);
    window.addEventListener('pagehide', function () { clearPreviewTransfer(false); });
    window.addEventListener('popstate', function () { clearPreviewTransfer(false); });
    new MutationObserver(function (mutations) {
      if (mutations.some(function (mutation) { return !mutation.target.closest?.('.myx-unified-size'); })) schedule();
    }).observe(document.getElementById('product-builder') || document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-pressed', 'aria-checked', 'data-maytrix-shape'] });
    document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', schedule);
    document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', schedule);
    document.addEventListener('change', schedule); schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
}());
